<template>
  <main>
    <v-dialog v-model="acceptDialog" max-width="420px">
      <DeleteModal
          title="Aceitar promoção dos produtos"
          textMessage="Tem certeza que quer aceitar a promoção dos produtos?"
          cancelBtn="Cancelar"
          okbtn="Aceitar"
          textObservation=""
          icone="mdi-trash-can-outline"
          @close="(acceptDialog = false)"
          @action="acceptPromotion"
      />
    </v-dialog>

    <v-dialog v-model="refuseDialog" max-width="420px">
      <DeleteModal
          title="Recusar promoção dos produtos"
          textMessage="Tem certeza que quer recusar a promoção dos produtos?"
          cancelBtn="Cancelar"
          okbtn="Recusar"
          textObservation=""
          icone="mdi-trash-can-outline"
          @close="(acceptDialog = false)"
          @action="refusePromotion"
      />
    </v-dialog>

    <Header
        buttonTitle="Promoção"
        title="Promoção"
        text="Promoção"
        @voltar="goToRoute('/promotions-center-resale')"
        :haveAction="false"
        :haveBack="true"
    />

    <v-card class="mx-3">
      <v-form ref="promotionForm" v-model="promotionForm" :key="clear">
        <v-row cols="12" sm="12" md="12" lg="12" class="ma-0">
          <v-col cols="12" sm="4" md="4" lg="4">
            <span class="ml-1 mb-2 label-details">Nome</span>
            <v-text-field
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                outlined
                type="text"
                hide-details
                :disabled="true"
                placeholder="Digite o nome da promoção"
                v-model="promotion.name"
                :rules="[rules.required]"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
            <span class="ml-1 mb-2 label-details">Tipo de Beneficio</span>
            <v-select
                :disabled="true"
                :items="status"
                v-model="promotion.discountType"
                hide-details
                height="52"
                style="border: 1px solid #979797; border-radius: 7.5px; width: 100%;!important;"
                background-color="#F5F5F5"
                placeholder="% ou R$"
                item-text="label"
                item-value="value"
                outlined
                required
                :rules="[(v) => !!v || 'Item is required']"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
            <label class="ml-1 mb-2 label-details">Desconto</label>
            <vuetify-money
                :disabled="true"
                color="black"
                v-bind:outlined="outlined"
                background-color="#F5F5F5"
                placeholder="0.0"
                :rules="[rules.required]"
                required
                hide-details
                style="border: 1px solid #979797; border-radius: 7.5px; width: 100%;!important;"
                v-model="promotion.discount"
                v-bind:options="options"
            >
            </vuetify-money>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
              <span class="ml-1 mb-2 label-details">
                Data de inicio da promoção
              </span>

            <v-text-field
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                outlined
                :disabled="true"
                type="date"
                hide-details
                v-model="promotion.start"
                :rules="[rules.required]"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
              <span class="ml-1 mb-2 label-details">
                Data de fim da promoção
              </span>

            <v-text-field
                :disabled="true"
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                outlined
                type="date"
                hide-details
                v-model="promotion.end"
                :rules="[rules.required]"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
            <v-btn
                v-if="resaleAcceptedPromotion"
                width="100%"
                height="56"
                class="add-button"
                color="quaternary"
                @click="refusePromotionModal()"
            >
              <span>Recusar promoção</span>
            </v-btn>

            <v-btn
                v-else
                width="100%"
                height="56"
                class="add-button"
                color="quaternary"
                @click="acceptPromotionModal()"
            >
              <span>Aceitar promoção</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <v-card class="mx-3">
      <h2 class="text-center py-1">Produtos adicionados</h2>
      <v-row cols="12" class="px-2">
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <div class="list-product-content">
            <div v-for="(item, index) in selectedProducts" class="ma-1" :key="`${item.productId}${index}`">
              <ImageCard
                  :key="item.productId"
                  :item="item"
                  :env_url="env_url"
                  :discountType="promotion.discountType"
                  :discount="promotion.discount"
              />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <br/>
    <br/>
    <br/>
  </main>
</template>

<script lang="js">
import ApiService from '../../../../services/ApiService';
import Header from "./Header";
import ImageCard from "./ImageCard";
import _ from 'underscore'
import moment from 'moment'
import DeleteModal from "../../components/DeleteModal";
import Vue from "vue";

export default {
  name: "PromotionsCenter",
  components: {
    Header,
    ImageCard,
    DeleteModal
  },

  data() {
    return {
      acceptDialog: false,
      refuseDialog: false,
      env_url: "",
      product: "",
      search: "",
      products: [],
      selectedProducts: [],
      promotionForm: null,
      currentPromotion: null,
      user: null,
      status: [
        {label: "Percentual", value: 1},
        {label: "Real", value: 2},
      ],
      promotion: {
        id: null,
        name: null,
        discount: 0,
        start: null,
        end: null,
        discountType: 1,
        products: [],
      },
      clear: false,
      apiService: new ApiService(),
      outlined: true,
      options: {
        locale: "pt-BR",
        prefix: "%",
        suffix: "",
        length: 11,
        precision: 1
      },
      rules: {
        nameRules: (v) => (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",
        required: (value) => !!value || "Campo requerido.",
        min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
        postalCodeRules: (v) => (v && v.length <= 10) || "CEP deve ter no máximo 10 caracteres",
      },
    }
  },
  created() {
    this.env_url = process.env.VUE_APP_BASE_URL;
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.promotion.id = this.$route.query.id
    if (this.promotion.id) {
      await this.getOnePromotion(this.promotion.id)
    }
  },
  computed: {
    resaleAcceptedPromotion(){
      if(this.promotion.promotionsResale) {
        return !!this.promotion.promotionsResale.find((x) => x.resaleId === this.user.id)
      }
      return false
    }
  },
  methods: {
    acceptPromotionModal() {
      this.currentPromotion = this.promotion;;
      this.acceptDialog = true;
    },
    refusePromotionModal() {
      this.currentPromotion = this.promotion;
      this.refuseDialog = true;
    },
    acceptPromotion() {
      try {
        this.loading = true;
        this.currentPromotion.resales = [this.user.id]
        this.currentPromotion.doneByAdminOrMasterUser = false;
        this.apiService.post('promotion/add-resale', this.currentPromotion).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Promoção aceita com sucesso!",
            trace: null,
          });
          await this.getOnePromotion(this.promotion.id)
          this.acceptDialog = false
          this.loading = false;
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível aceitar promoção, verifique os campos e tente novamente!",
            trace: null,
          });
          this.acceptDialog = false
          this.loading = false;
        })
      } catch (e) {

      }
    },

    refusePromotion() {
      try {
        this.loading = true;
        this.refuseDialog = false;
        this.currentPromotion.promotionToResaleId = this.currentPromotion.promotionsResale.find((promotion) => promotion.resaleId === this.user.id).id
        this.currentPromotion.doneByAdminOrMasterUser = false;
        this.currentPromotion.resaleId = this.user.id;
        this.apiService.post(`promotion/refuse`, this.currentPromotion).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Promoção recusada com sucesso!",
            trace: null,
          });
          await this.getOnePromotion(this.promotion.id)
          this.loading = false;
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível recusar promoção, verifique os campos e tente novamente!",
            trace: null,
          });
          this.loading = false;
        })
      } catch (e) {

      }
    },

    async getOnePromotion(id) {
      try {
        this.apiService
            .get(`promotion/get-one?id=${id}`)
            .then((response) => {
              this.promotion = response
              this.promotion.start = moment(this.promotion.start).format('YYYY-MM-DD')
              this.promotion.end = moment(this.promotion.end).format('YYYY-MM-DD')
              this.selectedProducts = response.promotionsProduct.map((x) => x.product)
            });
      } catch (e) {

      }
    },

    async back() {
      await this.goToRoute('/promotions-center')
    },

    async goToRoute(route) {
      if (this.$route.path !== route) {
        await this.$router.push(route);
      }
    },
  },

  watch: {
  }
};
</script>

<style scoped>
.list-product-content {
  /*display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(250px, auto));*/
}
.add-button {
  transition: 0.3s;
  font-weight: 700 !important;
  font-size: 16px !important;
  color: #ffffff !important;
  background: #bc0000 !important;
  border-radius: 7.5px !important;
  margin-top: 20px;
  text-transform: uppercase;
}

.add-button:hover {
  background: #e8161e !important;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
}

</style>
